import type { ComponentProps } from "react";
import { cn } from "../..";

interface CounterProps extends ComponentProps<"span"> {
	color?: "success" | "primary" | "secondary";
	size?: "small" | "medium";
	amount: number | string;
}

export function Counter(props: CounterProps) {
	const { color = "primary", size = "small", amount, className, ...remainingProps } = props;

	return (
		<span
			className={cn(
				className,
				{
					"bg-primary": color === "primary",
					"bg-success": color === "success",
					"bg-secondary": color === "secondary",
					"h-3.5 min-w-[0.875rem] text-[8px] leading-[0.875rem]": size === "small",
					"h-4 min-w-[1rem] text-[10px] leading-4": size === "medium",
				},
				"inline-flex items-center justify-center rounded-full px-1 text-center text-white",
			)}
			{...remainingProps}
		>
			{Number(amount) > 99 ? "99+" : amount}
		</span>
	);
}
